export enum ViewBoxSize {
  AudioTestDisconnected = 309,
  CamDesktop = 470,
  AudioTestActive = 534,
  CamMobile = 564,
}
